// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import 'element-ui/lib/theme-chalk/index.css';
import App from './App'
import router from './router'
import { Container, Button, Select, MessageBox, Option, DatePicker, Icon, Dropdown, DropdownMenu, DropdownItem, Input, Checkbox, CheckboxButton, Loading, Main, Message,Tabs,TabPane } from 'element-ui';
import VueResource from 'vue-resource'
import VueScroller from 'vue-scroller'
import axios from 'axios'
import store from './store/store'
import VueDirectiveImagePreviewer from 'vue-directive-image-previewer'
import i18n from './i18n/i18n'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import '../node_modules/swiper/dist/css/swiper.css'
import '../node_modules/swiper/dist/css/swiper.min.css'
import VueCropper from 'vue-cropper'
// require('../node_modules/swiper/dist/js/swiper.min.js')
import 'element-ui/lib/theme-chalk/index.css'
import 'vue-directive-image-previewer/dist/assets/style.css'
import preview from 'vue-photo-preview'
import 'vue-photo-preview/dist/skin.css'
Vue.use(preview)
Vue.config.productionTip = false //vue去掉警告
Vue.use(VueAwesomeSwiper)
Vue.use(Container).use(Button).use(Select).use(Option).use(DatePicker).use(Icon).use(Dropdown).use(DropdownMenu).use(DropdownItem).use(Input).use(Checkbox).use(CheckboxButton).use(Loading).use(Main).use(Tabs).use(TabPane)

// 添加请求拦截器
axios.interceptors.request.use(config => {
    // 在发送请求之前做些什么
    //判断是否存在token，如果存在将每个页面header都添加token
    if (store.state.token) {
        config.headers.common['x-auth-token'] = store.state.token
    }
    if (store.state.storeLang) {
        config.headers.common['x-lang'] = store.state.storeLang
    }
    if (store.state.resetToken) {
        config.headers.common['resetToken'] = store.state.resetToken
    }
    return config;
}, error => {
    // 对请求错误做些什么
    return Promise.reject(error);
});

// http response 拦截器
axios.interceptors.response.use(
    response => {
        return response;
    },
    error => {
        if (error.response) {
            switch (error.response.status) {
                case 401:
                    this.$store.commit('del_token');
                    router.replace({
                        path: '/login',
                        query: { redirect: router.currentRoute.fullPath } //登录成功后跳入浏览的当前页面
                    })
            }
        }
        return Promise.reject(error.response.data)// 返回接口返回的错误信息
    });

Vue.use(VueResource)
Vue.use(VueCropper)
Vue.use(VueDirectiveImagePreviewer)
Vue.use(VueScroller)
Vue.use(Loading.directive);
Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$prompt = MessageBox.prompt;
Vue.prototype.$alert = MessageBox.alert;
Vue.prototype.$message = Message;
new Vue({
    el: '#app',
    router,
    store,
    i18n,
    components: { App },
    template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js